import React,{useState,}from 'react'
import { Form,Input,App, Radio, Modal} from 'antd';
import { useQingqiucanshuAddMutation } from '../../store/BnsKeJiApi';
import {PlusSquareOutlined} from '@ant-design/icons';
const {TextArea} = Input
function ParamAdd(props) {    
    const {message} = App.useApp()
    const [open,setOpen] = useState(false)
    const [form] = Form.useForm();
    const [add]  = useQingqiucanshuAddMutation()
    const [info,setInfo] = useState({
        'qqcs_et_id': props.et_id,
        'qqcs_et_name': props.et_name,
        'qqcs_type': '',
        'qqcs_require': '',
        'qqcs_uid': props.eu_id,
        'qqcs_uname': props.eu_name,
        'qqcs_content': '',
        'qqcs_name': ''
    });
    return (
            <>
                <a onClick={() => {setOpen(true)}}><PlusSquareOutlined /> 新增</a>
                <Modal
                    title='新增请求参数'  
                    open={open}
                    width={800}
                    onCancel={() => {setOpen(false)}}
                    onOk={() => {
                        form.resetFields();  
                        add(info).then((res) => {
                            if (res.data.Status === 'success') {
                                message.info('新增成功！');
                                setOpen(false)
                            }
                            if (res.data.Status === "fail") {
                                message.error('新增失败！'+res.data.Message)
                            }
                        })      
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_client_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 4 }}  
                                            
                    >
                        <Form.Item name="qqcs_name" label='参数名称' wrapperCol={{span:10}} required>
                            <Input onChange={(e) => {setInfo(prevState=>({...prevState,qqcs_name:e.target.value}))}} />
                        </Form.Item> 
                        <Form.Item name="qqcs_type" label='参数类型' wrapperCol={{span:10}} required>
                            <Radio.Group onChange={(e) => {setInfo(prevState=>({...prevState,qqcs_type:e.target.value}))}}>
                                <Radio value='string'>string</Radio>
                                <Radio value='array'>array</Radio>
                            </Radio.Group> 
                        </Form.Item> 
                       
                        <Form.Item name="qqcs_require" label='是否可选' wrapperCol={{span:18}}>
                            <Radio.Group onChange={(e) => {setInfo(prevState=>({...prevState,qqcs_require:e.target.value}))}}>
                                <Radio value='必填'>必填</Radio>
                                <Radio value='可选'>可选</Radio>
                            </Radio.Group>                       
                        </Form.Item> 
                        <Form.Item name="qqcs_content" label='说明' wrapperCol={{span:18}}>
                            <TextArea 
                                onChange={(e) => {setInfo(prevState=>({...prevState,qqcs_content:e.target.value}))}}
                                rows={5}
                            />
                        </Form.Item>
                    </Form>
                </Modal>
            </>
        )
}

export default ParamAdd